import { ceData } from 'components/CeData';
import useReduxSelector from 'components/hooks/useReduxSelector';

export default function useBimContext({ listenToChanges = false } = {}) {
  if (listenToChanges) {
    return useReduxSelector((state) => state.context);
  }

  return ceData.context;
}
